export class FetchError extends Error {
  status: number;
  info: any;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
    this.name = 'FetchError';
    Object.setPrototypeOf(this, FetchError.prototype);
  }
}
